//====================================================
//  Function: Footer
//====================================================
function componentFooter() {
  // FOOTER
  if ($("#footer").length == 0) {
    $(".overall-wrapper").append(
      '<div class="zapati-group"></div><div class="footer-group"></div>'
    );
    $(".zapati-group").load("/ .zapati", function () {});
    $(".footer-group").load("/ #footer", function () {
      $("#footer .footer-rows").remove();
      componentChangeContent();
    });
  }
}
